import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Button from 'material-ui/Button';
import 'jquery-slimscroll/jquery.slimscroll.min';


class SideNavContent extends Component {
    componentDidMount() {
        const { history } = this.props;
        const $nav = $(this.nav);
        const slideDuration = 250;
        // console.log('SideNav Content this.props=>', this.props)
        $nav.slimscroll({
            height: '100%'
        });

        const pathname = `#${history.location.pathname}`;// get current path

        $('ul.nav-menu > li.menu').click(function () {
            const menuLi = this;
            $('ul.nav-menu > li.menu').not(menuLi).removeClass('open');
            $('ul.nav-menu > li.menu ul').not($('ul', menuLi)).slideUp(slideDuration);
            $('> ul', menuLi).slideToggle(slideDuration);
            $(menuLi).toggleClass('open');
        });

        $('ul.sub-menu li').click(function (e) {
            let superSubMenu = $(this).parent();
            if (superSubMenu.parent().hasClass('active')) {
                $('li', superSubMenu).not($(this)).removeClass('active');
            }
            else {
                $('ul.sub-menu li').not($(this)).removeClass('active');
            }

            $(this).toggleClass('active');
            e.stopPropagation();
        });

        const activeLi = $('a[href="' + pathname + '"]');// select current a element
        const activeNav = activeLi.closest('ul'); // select closest ul
        if (activeNav.hasClass('sub-menu')) {
            activeNav.slideDown(slideDuration);
            activeNav.parent().addClass('open');
            activeLi.parent().addClass('active');
        } else {
            activeLi.parent().addClass('open');
        }
    }


    render() {
        const { getCustomer } = this.props;
        let menu = null;
        if (this.props.loginUser && this.props.loginUser.data) {
            // Super Admin 
            if (this.props.loginUser.data.role_id == 1) {
                menu = [
                    <li key="1" className="nav-header badmin">Super Admin</li>,
                    <li key="2" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">Customer Details</span>
                        </Button>

                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/customer/add-customer">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Add Customer</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/customer/customer-list">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Customer List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">User Manuals</span>
                        </Button>
                        <ul className="sub-menu">

                            <li><a href="/Admin_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> Admin Manual </a> </li>

                            <li><a href="/IPad_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> iPad Manual </a> </li>

                        </ul>
                    </li>
                ]
            }
            // {/* Board Admin */ }
            else if (this.props.loginUser.data.role_id == 2) {
                menu = [
                    <li key="0" className="nav-header badmin">Board Admin</li>,
                    <li key="1" className="ui_tooltip menu">
                        <Button href="javascript:void(0)">
                            <i className="zmdi zmdi-accounts-list-alt zmdi-hc-fw" />
                            <span className="nav-text">User Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/user/add-user">
                                    <i className="zmdi zmdi-account-add zmdi-hc-fw" />
                                    <span className="nav-text">Add User</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/user/user-list">
                                    <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
                                    <span className="nav-text">User List</span>
                                </NavLink >
                            </li>
                            {getCustomer.isCheckerEnabled && getCustomer.isCheckerEnabled.ischecker_enabled == 1 ? <li>
                                <NavLink activeClassName='active' to="/user/pending-approval">
                                    <i className="zmdi zmdi-check-all zmdi-hc-fw" />
                                    <span className="nav-text">Pending Approval</span>
                                </NavLink >
                            </li> : null}
                            {getCustomer.isCheckerEnabled && getCustomer.isCheckerEnabled.ischecker_enabled == 1 ? <li>
                                <NavLink activeClassName='active' to="/user/rejected-roles">
                                    <i className="zmdi zmdi-mood-bad zmdi-hc-fw" />
                                    <span className="nav-text">Rejected Roles</span>
                                </NavLink >
                            </li> : null}
                            <li>
                                <NavLink activeClassName='active' to="/user/user-order">
                                    <i className="zmdi zmdi-mood-bad zmdi-hc-fw" />
                                    <span className="nav-text">User Order</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="2" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-accounts-outline zmdi-hc-fw" />
                            <span className="nav-text">Team Details</span>
                        </Button>

                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/team/add-team">
                                    <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                                    <span className="nav-text">Add Team</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/team/team-list">
                                    <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
                                    <span className="nav-text">Team List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="3" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-email-open  zmdi-hc-fw" />
                            <span className="nav-text">Mail List</span>
                        </Button>

                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/mail/mail-list">
                                    <i className="zmdi zmdi-email zmdi-hc-fw" />
                                    <span className="nav-text">Mail List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="4" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-collection-bookmark zmdi-hc-fw" />
                            <span className="nav-text">Audit Trail</span>
                        </Button>

                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/user">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">User Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/meeting">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Meeting Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/agenda">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Agenda Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/folder">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Folder Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/resolutions">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Resolution Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/decisions">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Decision Audit</span>
                                </NavLink >
                            </li>
                            {/* <li>
                                <NavLink activeClassName='active' to="audit/audit-list/AgendaFile">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Agenda File Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/folderFile">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Folder File Audit</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="audit/audit-list/resolutionFile">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Res File Audit</span>
                                </NavLink >
                            </li> */}
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">Template Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/template/template-list">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Templates List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">User Manuals</span>
                        </Button>
                        <ul className="sub-menu">

                            <li><a href="/Admin_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> Admin Manual </a> </li>

                            <li><a href="/IPad_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> iPad Manual </a> </li>

                        </ul>
                    </li>
                ]
            }
            // {/* checker */}
            else if (this.props.loginUser.data.role_id == 5) {
                menu = [
                    <li key="1" className="nav-header">checker</li>,
                    <li key="2" className="ui_tooltip menu">
                        <Button href="javascript:void(0)">
                            <i className="zmdi zmdi-accounts-list-alt zmdi-hc-fw" />
                            <span className="nav-text">User Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/user/checker-pending-approval">
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">Pending Approval</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/user/checker-rejected-roles">
                                    <i className="zmdi zmdi-mood-bad zmdi-hc-fw" />
                                    <span className="nav-text">Rejected Roles</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">User Manuals</span>
                        </Button>
                        <ul className="sub-menu">

                            <li><a href="/Admin_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> Admin Manual </a> </li>

                            <li><a href="/IPad_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> iPad Manual </a> </li>

                        </ul>
                    </li>
                ]
            }
            // {/* Meeting Admin */}
            else if (this.props.loginUser.data.role_id == 3) {
                menu = [
                    <li key="1" className="nav-header">Meeting Admin</li>,
                    <li key="2" className="ui_tooltip menu">
                        <Button href="javascript:void(0)">
                            <i className="zmdi zmdi-accounts-list-alt zmdi-hc-fw" />
                            <span className="nav-text">User Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/user/meeting-user-list">
                                    <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
                                    <span className="nav-text">User List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="3" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-account-box-mail zmdi-hc-fw" />
                            <span className="nav-text">Meeting Details</span>
                        </Button>

                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/meeting/add-meeting">
                                    <i className="zmdi  zmdi-format-indent-decrease zmdi-hc-fw" />
                                    <span className="nav-text">Add Meeting</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/meeting/meeting-list">
                                    <i className="zmdi zmdi-format-align-left zmdi-hc-fw" />
                                    <span className="nav-text">Meeting List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="4" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-flag zmdi-hc-fw" />
                            <span className="nav-text">Agenda Item Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/agenda/add-agenda-item">
                                    <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                                    <span className="nav-text">Add Agenda Item</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/agenda/agenda-item-list">
                                    <i className="zmdi zmdi-view-list zmdi-hc-fw" />
                                    <span className="nav-text">Agenda Item List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-view-carousel zmdi-hc-fw" />
                            <span className="nav-text">Library Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/document/add-document">
                                    <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                                    <span className="nav-text">Add Library</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/document/document-list">
                                    <i className="zmdi zmdi-file zmdi-hc-fw" />
                                    <span className="nav-text">Library List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="6" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-thumb-up  zmdi-hc-fw" />
                            <span className="nav-text">Resolution Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/resolution/add-resolution">
                                    <i className="zmdi zmdi-border-color zmdi-hc-fw" />
                                    <span className="nav-text">Add Resolution</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/resolution/resolution-list">
                                    <i className="zmdi zmdi-format-align-center zmdi-hc-fw" />
                                    <span className="nav-text">Resolution List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="7" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-star zmdi-hc-fw" />
                            <span className="nav-text">Assignee Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/assignee/add-assignee">
                                    <i className="zmdi zmdi-star-outline zmdi-hc-fw" />
                                    <span className="nav-text">Add Assignee</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/assignee/assignee-list">
                                    <i className="zmdi zmdi-format-list-bulleted zmdi-hc-fw" />
                                    <span className="nav-text">Assignee List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="8" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-calendar-note zmdi-hc-fw" />
                            <span className="nav-text">Decision Details</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/decision/add-decision">
                                    <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                                    <span className="nav-text">Add Decision</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/decision/decision-list">
                                    <i className="zmdi zmdi-format-line-spacing zmdi-hc-fw" />
                                    <span className="nav-text">Decision List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="9" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-border-color zmdi-hc-fw" />
                            <span className="nav-text">e-Signature Management</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/esignature/add-esignature">
                                    <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                                    <span className="nav-text">Add e-Signature</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/esignature/esignature-list">
                                    <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                                    <span className="nav-text">e-Signature List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="10" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-archive zmdi-hc-fw" />
                            <span className="nav-text">Archive Management</span>
                        </Button>
                        <ul className="sub-menu">
                            <li>
                                <NavLink activeClassName='active' to="/archive/archive-meeting-list">
                                    <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                                    <span className="nav-text">Meeting List</span>
                                </NavLink >
                            </li>
                            <li>
                                <NavLink activeClassName='active' to="/archive/archive-agenda-list">
                                    <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                                    <span className="nav-text">Agenda List</span>
                                </NavLink >
                            </li>
                        </ul>
                    </li>,
                    <li key="5" className="ui_tooltip menu">
                        <Button className="void" href="javascript:void(0)">
                            <i className="zmdi zmdi-folder zmdi-hc-fw" />
                            <span className="nav-text">User Manuals</span>
                        </Button>
                        <ul className="sub-menu">

                            <li><a href="/Admin_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> Admin Manual </a> </li>

                            <li><a href="/IPad_Manual.pdf" download target="_blank">  <i className="zmdi zmdi-file-text" /> iPad Manual </a> </li>

                        </ul>
                    </li>
                ]
            }
        }
        return (
            <ul className="nav-menu" ref={(c) => {
                this.nav = c;
            }}>

                <li className="nav-header"></li>
                {menu}

            </ul>
        );
    }
}

export default withRouter(SideNavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js